
export type ChatMessageSummaryBasicInfoAllOfTwoType = typeof ChatMessageSummaryBasicInfoAllOfTwoType[keyof typeof ChatMessageSummaryBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMessageSummaryBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
